export const InscripcionClientesLang = {
    Titulo: {
      es: 'FORMATO DE INSCRIPCIÓN DE CLIENTES',
      en: 'CUSTOMERS INSCRIPTION FORM',
    },
    codigoCliente: {
      es: 'Código de Cliente',
      en: 'Customer code',
    },
    informacionClienteTitle: {
      es: 'Información del Cliente',
      en: 'Customer information',
    },
    'Descargar Manual': {
        es: 'Descargar Manual',
        en: 'Download Manual',
    },
    'NombreCliente': {
      'es': 'Nombre Cliente',
      'en': 'Cutomer Name'
    },
    'NumIdentificacionTributaria': {
      'es': 'RTN/NIT/RC/TAX ID',
      'en': 'RTN/NIT/RUC/TAX ID'
    },
    'NombreAbreviado': {
        'es': 'Abreviación',
        'en': 'Abbreviation'
      },
    'Pais': {
      'es': 'País',
      'en': 'Country'
    },
    'Estado': {
      'es': 'Estado / Región',
      'en': 'State / Region'
    },
    'Ciudad': {
      'es': 'Ciudad',
      'en': 'City'
    },
    'DireccionComercial': {
      'es': 'Dirección Comercial',
      'en': 'Commercial Address'
    },
    'informacionContacto': {
        'es': 'Información de Contacto',
        'en': 'Contact information'
    },
    'nombreContacto': {
        'es': 'Contacto',
        'en': 'Contact'
    },
    'nombreContacto1': {
        'es': 'Nombre Contacto',
        'en': 'Contact Name'
    },
    'TelefonoRef': {
        'es': 'Número de teléfono',
        'en': 'Phone number'
    },
    'TelefonoSec': {
        'es': 'Número de teléfono secundario',
        'en': 'Secondary phone number'
    },
    'Email': {
        'es': 'Correo electrónico',
        'en': 'Email'
    },
    'EmailSec': {
        'es': 'Correo electrónico secundario',
        'en': 'Secondary Email'
    },
    'informacionFactura': {
        'es': 'Información de Facturación',
        'en': 'Billing information'
    },
    'tipoPago': {
        'es': 'Tipo de Pago',
        'en': 'Payment type'
    },
    'unidades': {
        'es': 'Unidades',
        'en': 'Units'
    },
    'limiteCredito': {
        'es': 'Límite de Crédito',
        'en': 'Credit limit'
    },
    'terminos': {
        'es': 'Términos',
        'en': 'Terms'
    },
    'terminosFlete': {
        'es': 'Términos Flete',
        'en': 'Freight Terms'
    },
    'porcentaje': {
        'es': 'Porcentaje de Exportación',
        'en': 'Export Percentage'
    },
    'comentario': {
        'es': 'Comentario',
        'en': 'Comment'
    },
    'actividadEconomica': {
        'es': 'Principal actividad económica',
        'en': 'Main economic activity'
    },
    'TipoFacturacion': {
        'es': 'Metodo de pago',
        'en': 'Payment method'
    },
    'nombreCasaMatriz': {
        'es': 'Nombre de la casa matriz',
        'en': 'Headquarters name'
    },
    'distCasaMatriz': {
        'es': 'Si es distinto al nombre comercial.',
        'en': 'If it is different from the commercial name.'
    },
    'direccionCasaMatriz': {
        'es': 'Dirección de la casa matriz',
        'en': 'Headquarters address'
    },
    'distDireccionComercial': {
        'es': 'Si es distinto de la Dirección Comercial.',
        'en': 'If it is different from the Commercial Address.'
    },

    'completarCamposObligatorios': {
        'es': 'Completar los campos obligatorios.',
        'en': 'Complete the required fields.'
    },

    'informacionContactoRepresentanteLegal': {
        'es': 'Información de contacto del representante legal',
        'en': 'Contact information of the legal representative'
    },
    'Nombre': {
        'es': 'Nombre',
        'en': 'Name'
    },
    'inforamcionContactoCuentasPagar': {
        'es': 'Información de contacto de cuentas por pagar',
        'en': 'Accounts Payable Contact Information'
    },
    'numeroTelefono': {
        'es': 'Número de teléfono',
        'en': 'Phone number'
    },
    'informacionBancaria': {
        'es': 'Información bancaria',
        'en': 'Bank information'
    },
    'numeroCuenta': {
        'es': 'Número de cuenta',
        'en': 'Account number'
    },
    'titularCuenta': {
        'es': 'Titular de cuenta',
        'en': 'Account holder'
    },
    'Banco': {
        'es': 'Banco',
        'en': 'Bank'
    },
    'tipoCuenta': {
        'es': 'Tipo de cuenta',
        'en': 'Account type'
    },
    'Moneda': {
        'es': 'Moneda',
        'en': 'Currency'
    },
    'bancoIntermediario': {
        'es': 'Banco Intermediario',
        'en': 'Intermediary bank',
    },
    'bancoBeneficiario': {
        'es': 'Banco Beneficiario',
        'en': 'Beneficiary bank',
    },
    'Direccion': {
        'es': 'Dirección',
        'en': 'Address'
    },
    'Swift': {
        'es': 'Swift',
        'en': 'Swift'
    },
    'ABA / BIN': {
        'es': 'ABA / BIN',
        'en': 'ABA / BIN'
    },
    'nombreBeneficiario': {
        'es': 'Nombre del Beneficiario',
        'en': 'Beneficiary Name'
    },
    'referenciasComerciales': {
        'es': 'Referencias Comerciales',
        'en': 'Commercial references'
    },
    'referenciasBancarias': {
        'es': 'Referencias Bancarias',
        'en': 'Bank References'
    },
    'Referencia': {
        'es': 'Referencia',
        'en': 'Reference'
    },
    'RefLoad':{
        'es': 'Por favor cargue la Referencia impresa',
        'en': 'Please load the printed Reference'
    },
    'adjuntarDocumentos': {
        'es': 'Adjuntar los siguientes documentos.',
        'en': 'Attach the following documents.'
    },
    'Documentation': {
        'es': 'Documentación',
        'en': 'Documentation'
    },
    'PermisoOperaciones': {
        'es': 'Permiso de operaciones',
        'en': 'Operation license'
    },
    'escrituraConstitucion': {
        'es': 'Escritura de constitución',
        'en': 'Articles of Incorporation'
    },
    'zonaLibre': {
        'es': ' Es Zona Libre',
        'en': 'It`s a free zone'
    },
    'si': {
        'es': 'Si',
        'en': 'Yes'
    },
    'no': {
        'es': 'No',
        'en': 'No'
    },
    'nombreZona': {
        'es': 'Nombre Zona',
        'en': 'Zone Name'
    },
    'direccionZona': {
        'es': 'Dirección Zona',
        'en': 'Zone Address'
    },
    'registroExonerado': {
        'es': 'Registro exonerado',
        'en': 'Exempt registration'
    },
    'constPagosCuenta': {
        'es': 'Constancia de pagos a cuenta',
        'en': 'Proof of payments on account'
    },
    'noPermiso': {
        'es': 'NO TIENES PERMISOS PARA VER ESTA PÁGINA',
        'en': 'YOU DO NOT HAVE PERMISSIONS TO VIEW THIS PAGE'
    },

    'guardar': {
        'es': 'Enviar Solicitud',
        'en': 'Submit request'
    },
    'limpiar': {
        'es': 'Limpiar',
        'en': 'Clean'
    },
    'infCierta': {
        'es': 'La Información proporcionada en el presente formulario se considerará como cierta, por lo que nuestra responsabilidad únicamente se limita al análisis de la información proporcionada por el cliente.',
        'en': 'The information provided in this form will be considered true, our accountability is limited to its analysis and validation only.'
    },
    'registroCompleto': {
        'es': 'Registro guardada correctamente.',
        'en': 'The information has been submitted successfully. '
    },
    'msgConfirmacion': {
        'es': '¿Estas seguro que deseas guardar la información?',
        'en': 'Are you sure about the entered information?'
    },
    'msgNoEditable': {
        'es': 'Una vez que lo envíe, puede comunicarse con un agente de PPF para permitir el acceso nuevamente si se requiere alguna corrección.',
        'en': 'Once you send it, you may contact a PPF agent to allow access again if any correction is required.'
    },
    'msgConfirmacionIncompleta': {
        'es': '¿Estas seguro que deseas guardar la información Incompleta?',
        'en': 'Are you sure you want to save incomplete information?'
    },
    'msgNoEditableIncompleta': {
        'es': 'La inscripción se completará exitosamente una vez que haya proporcionado toda la información requerida.',
        'en': 'The registration will be successfully completed once you have provided all the required information.'
    },
    'InformacionFaltante': {
        'es': 'Información Faltante',
        'en': 'Missing Information'
    },
    'paisConstitucion': {
        'es': 'País de constitución',
        'en': 'Country of incorporation'
    },
    'siEsDistintoAnterior': {
        'es': 'Si es distinto al anterior',
        'en': 'If different from the previous one'
    },
    'ContactoCuentasPorCobrar': {
        'es': 'Contacto de cuentas por cobrar (persona encargada de confirmar pagos)',
        'en': 'Accounts receivable contact (person in charge of confirming payments)'
    },
    'representanteLegal': {
        'es': 'Representante legal',
        'en': 'Legal representative'
    },
    'nombreCompañia': {
        'es': 'Nombre de la compañia',
        'en': 'Company name'
    },
    'TelefonoSmall': {
        'es': 'Tel.',
        'en': 'Phone'
    },
    'nombreBanco': {
        'es': 'Nombre del banco',
        'en': 'Bank name'
    },
    'direccionBanco': {
        'es': 'Dirección del banco',
        'en': 'Bank address'
    },
    'declaracion': {
        'es': 'Declaro que la información anterior es correcta. Entiendo que "Pride Performance Fabrics, S.A de C.V" podrá contactar y/o utilizar otras fuentes que le permitan investigar la información credicia que considere necesaria para este fin. Autorizamos a las empresas comerciales que figuran en esta solicitud a proveer lo necesario para ayudar a "Pride Performance Fabrics, S.A de C.V", a establecer una línea de crédito.',
        'en': 'I declare that the above information is correct. I understand that "Pride Performance Fabrics, S.A de C.V", may contact and / or use other sources to enable it to investigate credit information deemed necessary for this purpose. Autorize commercial companies listed in this application to disclose the necessary to help "Pride Performance Fabrics, S.A de C.V", to establish a line of credit.'
    },
    'msgContacto': {
        'es': '*Si tiene alguna duda con respecto a algún espacio, por favor escriba o llame al',
        'en': '*If you have any doubt regarding any blank to fill, please write or call to'
        
    },
    'msgValidacion': {
        'es': '*Esta información es muy importante. Los datos bancarios se validarán mediante llamada telefónica al recibir el formulario completo.',
        'en': '*This information is strongly required. After receiving this form, we will contac the accounts receivables executive.'
    },
    'msgValidacionNacional': {
        'es': 'Autorizo a la empresa Pride Perfomance Fabrics, S. A. de C.V. (PPF) con RTN 05019013550285, con la que tengo relación como proveedor a realizar los depósitos correspondientes a los pagos por concepto de productos entregados y/o servicios prestados.',
        'en': 'I authorize the company Pride Perfomance Fabrics, S. A. de C.V. (PPF) with RTN 05019013550285, with whom I have a relationship as a supplier to make the deposits corresponding to the payments for the products delivered and / or services provided.'
    },
    'parte': {
        'es': 'PARTE',
        'en': 'PART'
    },
    'informacionGeneral': {
        'es': 'Información general',
        'en': 'General information'
    },
    'tipoSolictud': {
        'es': 'Tipo de solicitud',
        'en': 'Type of request'
    },
    'Inscripción': {
        'es': 'Inscripción',
        'en': 'Registration'
    },
    'Actualización': {
        'es': 'Actualización',
        'en': 'Update'
    },
    'cuentaBancariaNacional': {
        'es': 'Dichos depósitos deberán efectuarse en la cuenta No.',
        'en': 'Such deposits must be made in account No.'
    },
    'RTN': {
        'es': 'RTN de la empresa',
        'en': 'Company RTN'
    },
    'CorreoNotificacionPago': {
        'es': 'Correo electrónico para notificación de pagos',
        'en': 'Email for payment notification'
    },
    'Imprimir': {
        'es': 'Imprimir y firmar',
        'en': 'Print and Sign'
    },
    'ArchivoActual': {
        'es': 'Archivo actual',
        'en': 'Current file'
    },
    'agregarFormatoInscripcion': {
        'es': 'Agregar Formato de inscripción:',
        'en': 'Add Registration Form:'
    },
    'archivoGuardado': {
        'es': 'Archivo guardado',
        'en': 'File saved'
    },
    'descargarArchivoAcutal': {
        'es': 'Descargar archivo actual',
        'en': 'Download current file'
    },
    'aNombreDe': {
        'es': 'A nombre de',
        'en': 'In favor of'
    },
    'ErrorArchivoTamaño': {
        'es': 'No se permiten archivos de 5MB o más.',
        'en': 'Files of 5MB or more are not allowed.'
    },
    'Factura': {
        'es': 'Factura/Orden de Compra/Direccion',
        'en': 'Invoice/Purchase Order/Address'
    },
    'EstadoF': {
        'es': 'Estado Financiero últimos 6 meses',
        'en': 'Financial Statements last 6 months'
    },
    'inforamcionContactoFinanzas':{
        'es': 'Información contacto finanzas',
        'en': 'Finance contact information'
    },
    'Contacto':{
        'es': 'Contacto',
        'en': 'Contact'
    },
    'InformacionFinan':{
        'es': 'Información Financiera últimos 6 meses',
        'en': 'Financial Information last 6 months'
    },
    'Activos':{
        'es': 'Activos',
        'en': 'Assets'
    },
    'ActCorr':{
        'es': 'Activos Corrientes',
        'en': 'Current assets'
    },
    'TotalAct':{
        'es': 'Total Activos',
        'en': 'Total assets'
    },
    'Pasivos':{
        'es': 'Pasivos',
        'en': 'Liabilities'
    },
    'ActPas':{
        'es': 'Pasivos Corrientes',
        'en': 'Current Liabilities'
    },
    'TotalPas':{
        'es': 'Total Pasivos',
        'en': 'Total Liabilities'
    },
    // 'autorizacionPagos': {
    //     'es': `1) Por medio de la presente, declaramos que la información proporcionada en el presente formulario es correcta. Entendemos que “Pride Performance Fabrics, S.A de C.V”, podrá contactar a el departamento de cuentas por cobrar o contabilidad para su validación. Autorizamos a las empresas comerciales enumeradas en esta solicitud a proporcionar lo necesario para ayudar a "PPF" a establecer una relación comercial con nosotros.

    //     2) Entendemos que: la información bancaria proporcionada, ha sido verificada previo a ser compartida, por lo que “Pride Performance Fabrics, S.A de C.V” podrá emitir pagos a las mismas sin responsabilidad alguna por errores de escritura, siempre y cuando se utilice la información completada por nosotros.`,
    //     'en': 'Hereby, we declare that the above information is correct. We understand that "Pride Performance Fabrics, S.A de C.V", may contact or accounts receivables or accounting department for its validation. We Authorize the commercial companies listed in this application to disclose the necessary to help "PPF" to establish a commercial relationship.'
    // },
    autorizacionPagos : {
        'es': `Por medio de la presente, declaramos que la información proporcionada en el presente formulario es correcta. Entendemos que “Pride Performance Fabrics, S. A. de C. V.”, podrá contactar a el departamento de cuentas por pagar o contabilidad para su validación. Autorizamos a las empresas comerciales enumeradas en esta solicitud a proporcionar lo necesario para ayudar a "PPF" a establecer una relación comercial con nosotros.`,
        'en':  `By means of this document, we declare that the information provided in this form is correct. We understand that 'Pride Performance Fabrics, S. A. de C. V.' may contact the accounts payable or accounting department for validation. We authorize the commercial companies listed in this application to provide the necessary information to assist 'PPF' in establishing a business relationship with us.`
    },
    dialogFinal: {
        'es': `Su solicitud de crédito está en revisión. Si necesitamos más información, se la pediremos. Una vez los datos sean evaluados, le notificaremos el resultado. Si esta solicitud es aprobada, también le informaremos las condiciones del crédito.`,
        'en': `Your credit application is under review. If we need more information, we will request it. Once the data has been evaluated, we will notify you of the outcome. If this application is approved, we will also inform you of the credit terms.`
    },
    'Asunto': {
        'es': 'Inscripción de información del Cliente',
        'en': 'Customer information registration'
      },
    'Socios': {
        'es': 'Principales Socios / Accionistas',
        'en': 'Main Partners / Shareholders'
    },
    'Directores': {
        'es': 'Directores de la Empresa',
        'en': 'Company Directors'
    },
    'Identificacion': {
        'es': 'Identificación',
        'en': 'Identification'
    },
    'IdentificacionReg': {
        'es': 'Documento de Identificación Tributaria(RTN)',
        'en': 'Tax Identification Document'
    },

    'Porcentaje': {
        'es': '% de Participación',
        'en': 'Participation %'
    },
    ErrNombre: {
        es: 'Ingrese el nombre',
        en: 'Enter the nam',
    },
    ErrId: {
        es: 'Ingrese la identificación',
        en: 'Enter ID',
    },
    ErrAddress: {
        es: 'Ingrese la dirección',
        en: 'Enter the address',
    },
    ErrParticipacion: {
        es: 'Ingrese el porcentaje de participación del Accionista',
        en: 'Enter Shareholder`s ownership percentage',
    },
    ErrNacionalidad: {
        es: 'Ingrese la nacionalidad',
        en: 'Enter the nationality',
    },
    ErrPosicion: {
        es: 'Ingrese la posición',
        en: 'Enter position',
    },
    ErrEmail: {
        es: 'Ingrese el correo electrónico',
        en: 'Enter email',
    },
    CertificadoAmbiental: {
        es: 'Certificado de cumplimiento ambiental vigente',
        en: 'Environmental compliance certificate',
    },
    CertificadoLaboral: {
        es: 'Certificado de cumplimiento laboral vigente',
        en: 'Labor compliance certificate',
    },
    BilledToAddress: {
        es: 'Correo de envío de facturas',
        en: 'Invoice sending email',
    },
    InvoicesToBe: {
        es: 'Facturas a Ser Facturadas a',
        en: 'Invoices To Be Billed To',
    },

    CompanyRefComercial: {
        es: 'Nombre de Compañía',
        en: 'Company Name',
    },

    BankName: {
        es: 'Nombre del Banco',
        en: 'Bank Name',
    },
    'Formato de inscripción':{
        es: 'Formato de Inscripción',
        en: 'Registration Format'
    },
    Nacionalidad: {
        es: 'Nacionalidad',
        en: 'Nacionality',
    },
    Posicion: {
        es: 'Posición',
        en: 'Position',
    },
    guardarBorrador: {
        es: 'Guardar borrador',
        en: 'Save as draft',
    },
    'Agregar Accionista': {
        'es': 'Agregar Accionista',
        'en': 'Add Shareholder'
    },
    'Agregar Director': {
        'es': 'Agregar Director',
        'en': 'Add Director'
    },
    'SolicitaCredito': {
        'es': 'Solicita Crédito',
        'en': 'Request Credit'
    },
    Cargar: {
        es: 'Elegir',
        en: 'Choose',
    },
    Enviar: {
        es: 'Enviar',
        en: 'Send',
    },    
    Cancelar: {
        es: 'Cancelar',
        en: 'Cancel',
    },
    InscripcionFinalizada: {
        es: 'La información ha sido guardada exitosamente.',
        en: 'The information has been saved successfully.'
    },
    InscripcionFinalizada2: {
        es: 'Se verificara la información proporcionada.',
        en: 'The information provided will be verified.'
    },
    msgCompleta:{
        es: 'La información se ha guardado exitosamente. Imprima y firme el archivo con el formato de inscripción y luego adjúntelo.',
        en: 'The information has been successfully saved. Print and sign the registration form, then attach the file.'
    }
}